export const TimeoutObject = Object.create(null);

export const timeout = (ms: number) => new Promise(resolve => setTimeout(() => resolve(TimeoutObject), ms));
